import { useQuery } from '@tanstack/react-query';
import { ALLOWED_NPI_QUERY_KEYS } from '../../constants/allowed-npis';
import { getAllowedNpis } from '../../services/allowed-npis.service';

export const useGetAllowedNpis = () =>
  useQuery([ALLOWED_NPI_QUERY_KEYS.GET_ALLOWED_NPI], () => getAllowedNpis(), {
    refetchOnWindowFocus: false,
  });
